import { useEffect } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

const WIDGET_ID = "694eee54261ca12bd7a9a48f";

function positionWidget() {
  const selectors = [
    `[data-widget-id="${WIDGET_ID}"]`,
    ".lc_text-widget",
    ".lc-text-widget-container",
    "#lc-text-widget-container",
    'iframe[src*="leadconnectorhq.com"]',
    'iframe[src*="leadconnectorhq.com/chat-widget"]',
  ];

  document.querySelectorAll<HTMLElement>(selectors.join(",")).forEach((element) => {
    element.style.setProperty("left", "auto", "important");
    element.style.setProperty("right", "max(1rem, env(safe-area-inset-right))", "important");
    element.style.setProperty("bottom", "max(1rem, env(safe-area-inset-bottom))", "important");
    element.style.setProperty("top", "auto", "important");
    element.style.setProperty("transform", "none", "important");
    element.style.setProperty("margin", "0", "important");
    element.style.setProperty("z-index", "45", "important");
  });
}

export function SupportChatWidget() {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) {
      // Clean up widget if it was previously loaded (e.g. resize from desktop to mobile)
      const existingScript = document.querySelector(
        `script[data-widget-id="${WIDGET_ID}"]`
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
      // Remove the widget container injected by the script
      const widgetContainer = document.querySelector(`[data-widget-id="${WIDGET_ID}"]`);
      if (widgetContainer) {
        widgetContainer.remove();
      }
      // Remove any iframe/container the widget may have injected
      const chatWidgetElements = document.querySelectorAll('.lc_text-widget, .lc_text-widget-container');
      chatWidgetElements.forEach(el => el.remove());
      return;
    }

    // Desktop: load the chat widget
    const existingScript = document.querySelector(
      `script[data-widget-id="${WIDGET_ID}"]`
    );
    const observer = new MutationObserver(() => positionWidget());
    observer.observe(document.body, { childList: true, subtree: true });

    if (existingScript) {
      positionWidget();
      return () => observer.disconnect();
    }

    const script = document.createElement("script");
    script.src = "https://beta.leadconnectorhq.com/loader.js";
    script.setAttribute(
      "data-resources-url",
      "https://beta.leadconnectorhq.com/chat-widget/loader.js"
    );
    script.setAttribute("data-widget-id", WIDGET_ID);
    script.async = true;
    script.addEventListener("load", positionWidget);
    document.body.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector(
        `script[data-widget-id="${WIDGET_ID}"]`
      );
      if (scriptToRemove) {
        document.body.removeChild(scriptToRemove);
      }
      observer.disconnect();
    };
  }, [isMobile]);

  return null;
}
